module.exports = __webpack_public_path__ + "img/India.97b22f7c.jpeg";